import axios from 'axios'
import { NODE_BASE_URL, getAxiosOptions } from './serviceHelper'

export const listDataService = {
  getData: async (user, listId) => {
    return await axios.get(
      `${NODE_BASE_URL}/template/list-data/list/${listId}`,
      getAxiosOptions(user),
    )
  },
  getDataActivity: async (user, activityId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/template/list-data/activity-list-data/${activityId}`,
        getAxiosOptions(user),
      )
    ).data
  },
  getListDataMetadata: async (user, activityTemplateId) => {
    return await axios.get(
      `${NODE_BASE_URL}/template/field/activity/list-data-metadata/${activityTemplateId}`,
      getAxiosOptions(user),
    )
  },
  getListOfListsForAdmin: async (user) => {
    return (await axios.get(`${NODE_BASE_URL}/template/list/company`, getAxiosOptions(user))).data
  },
  getChildrenByParent: async (user, parentId) => {
    return (
      await axios.get(
        `${NODE_BASE_URL}/template/list-data/children-by-parent/${parentId}`,
        getAxiosOptions(user),
      )
    ).data
  },
  getPlaceholderPrefetch: async (user, activityTemplateId, processId, processReferenceNum, processTemplateId, localProcessData) => {
    return (
      await axios.post(
        `${NODE_BASE_URL}/template/field/placeholder-prefetch/${activityTemplateId}`,
        { localProcessData },
        {
          ...getAxiosOptions(user),
          params: { process_id: processId, process_reference_num: processReferenceNum, process_template_id: processTemplateId },
        },
      )
    ).data
  },
}
